import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录', public: true }
  },
  {
 path: '/',
 name: 'Dashboard',
 component: () => import('../views/Dashboard.vue'),
 meta: { title: '全局统计', requiresAuth: true }
 },
 {
	 path: '/ip-stats',
	 name: 'IpStats',
	 component: () => import('../views/IpStats.vue'),
	 meta: { title: 'IP访问统计', requiresAuth: true }
	},
  {
    path: '/ip-manage',
    name: 'IpManage',
    component: () => import('../views/IpManage.vue'),
    meta: { title: 'IP管理', requiresAuth: true }
  },
 {
 path: '/recent-visits',
 name: 'RecentVisits',
 component: () => import('../views/RecentVisits.vue'),
 meta: { title: '最近访问记录', requiresAuth: true }
 },
 {
 path: '/suspicious-ip',
 name: 'SuspiciousIp',
 component: () => import('../views/SuspiciousIp.vue'),
 meta: { title: '可疑IP预警', requiresAuth: true }
 },
 {
 path: '/page-analytics',
 name: 'PageAnalytics',
 component: () => import('../views/PageAnalytics.vue'),
 meta: { title: '页面分析', requiresAuth: true }
 },
 {
 path: '/visitor-behavior',
 name: 'VisitorBehavior',
 component: () => import('../views/VisitorBehavior.vue'),
 meta: { title: '访客行为', requiresAuth: true }
 },
 {
 path: '/behavior-depth',
 name: 'BehaviorDepth',
 component: () => import('../views/BehaviorDepth.vue'),
 meta: { title: '深度分析', requiresAuth: true }
 },
 {
 path: '/realtime-screen',
 name: 'RealtimeScreen',
 component: () => import('../views/RealtimeScreen.vue'),
 meta: { title: '实时大屏', requiresAuth: true }
 },
  {
    path: '/websites',
    name: 'WebsiteList',
    component: () => import('../views/WebsiteList.vue'),
    meta: { title: '网站管理', requiresAuth: true }
  },
  {
    path: '/website/create',
    name: 'WebsiteCreate',
    component: () => import('../views/WebsiteForm.vue'),
    meta: { title: '新增网站', requiresAuth: true, requiresSuper: true }
  },
  {
    path: '/website/edit/:id',
    name: 'WebsiteEdit',
    component: () => import('../views/WebsiteForm.vue'),
    meta: { title: '编辑网站', requiresAuth: true, requiresSuper: true }
  },
  {
    path: '/website/stats/:id',
    name: 'WebsiteStats',
    component: () => import('../views/WebsiteStats.vue'),
    meta: { title: '网站统计', requiresAuth: true }
  },
  {
    path: '/admin-users',
    name: 'AdminUserList',
    component: () => import('../views/AdminUserList.vue'),
    meta: { title: '账号管理', requiresAuth: true, requiresSuper: true }
  },
  {
    path: '/admin-user/create',
    name: 'AdminUserCreate',
    component: () => import('../views/AdminUserForm.vue'),
    meta: { title: '新增账号', requiresAuth: true, requiresSuper: true }
  },
  {
    path: '/admin-user/edit/:id',
    name: 'AdminUserEdit',
    component: () => import('../views/AdminUserForm.vue'),
    meta: { title: '编辑账号', requiresAuth: true, requiresSuper: true }
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 网站流量统计平台';
  }

  const token = localStorage.getItem('wt_token');

  if (to.meta.public) {
    if (token && to.path === '/login') {
      next('/');
    } else {
      next();
    }
    return;
  }

  if (to.meta.requiresAuth && !token) {
    next('/login');
    return;
  }

  if (to.meta.requiresSuper) {
    try {
      const user = JSON.parse(localStorage.getItem('wt_user') || '{}');
      if (!user.is_super) {
        next('/');
        return;
      }
    } catch (e) {
      next('/login');
      return;
    }
  }

  next();
});

export default router;
